var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.77635684e-13%",
    y1: "42.3540893%",
    x2: "47.7727725%",
    y2: "46.9538638%",
    id: "linearGradient-hyk89irp1q-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.853553185%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-hyk89irp1q-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-May-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cancelation-3",
    transform: "translate(-499.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(469.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swiftfill",
    transform: "translate(30.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF3C4F",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.533333, 3.309482)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.666667, 11.243278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13893289,12.3898593 C5.13893289,12.3898593 6.68789688,12.9472333 8.70605223,13.0679729 C11.5683303,13.2391291 13.3487273,15.0695707 13.3487273,15.0695707 C9.9083008,15.0225028 7.13315116,15.7542577 5.13893289,12.3898593 Z M11.7850867,-2.36847579e-15 L20.200757,7.86346643 L18.4305182,14.3201869 C18.4305182,14.3201869 17.885756,10.4059128 10.0096007,9.03303566 C1.43689389,7.53861259 0,1.17357624 0,1.17357624 C4.30254211,2.20174697 8.98500933,0.943260887 10.8970705,0.315733271 L11.1403383,0.234346229 C11.5537626,0.0933113224 11.7850867,-2.36847579e-15 11.7850867,-2.36847579e-15 L11.7850867,-2.36847579e-15 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-hyk89irp1q-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7931077,1.97238347 C11.3433725,1.3607177 11.9685465,0.779082613 12.6821379,0.232725201 C13.0053306,-0.0156698218 13.4593632,0.000294442632 13.7642471,0.270682193 C14.8289408,1.2120156 16.0933552,1.87280218 17.6102952,2.17891416 C17.7841159,2.21385692 17.9626254,2.21921555 18.1382323,2.19454351 C18.792209,2.1027769 20.5711639,1.85304222 21.6550593,1.70087933 C21.8380343,1.67520255 22.0208977,1.74832557 22.1357734,1.89312034 C22.2506491,2.0379151 22.2801216,2.23272378 22.2134736,2.40509318 C21.9069151,3.19694302 21.4582411,4.35563603 21.2294944,4.94731855 C21.1323692,5.19839289 21.1783641,5.47023194 21.139514,5.73648908 C20.6810159,8.88569142 27.310986,15.5640009 26.61548,17.0182003 C25.9198623,18.4723996 18.9338778,16.7008128 16.9660311,14.4616852 C16.6423919,14.0935024 16.2311167,13.6688306 15.7630177,13.2066484 C15.438597,12.8863584 15.0620414,12.5288928 14.7836157,12.2598448 C14.1416959,11.6491837 13.4456317,11.0011239 12.7510187,10.3498266 C11.8765566,9.50773954 11.6528336,9.29227779 10.1322095,7.82791935 C9.71479425,7.40559199 9.33388467,7.00358279 9.00857092,6.63339048 C8.85116104,6.45432279 8.7403043,6.2463408 8.6777869,6.02641352 C8.79656995,3.86933997 9.71624555,4.03635074 10.7931077,1.97238347 Z",
    id: "SVGID_2_",
    fill: "url(#linearGradient-hyk89irp1q-2)",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLogo);
export default __webpack_public_path__ + "static/media/red-logo.bb36a2586d931f082ad66a74a1bc3ecd.svg";
export { ForwardRef as ReactComponent };